var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"dense":"","align":"stretch"}},[_c('ColSummary'),_vm._l((_vm.bills),function(item,i){return _c('v-col',{key:i,attrs:{"cols":"12"}},[_c('CardBill',{attrs:{"bill":item}})],1)})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }